<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ruch magazynowy</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="hasSameProjectAndTeamName()">

            <small v-if="checkWarehouses && !this.selectedItems?.quote_request_item_id" class="text-warning">
              Nie można wybrać innego magazynu niż główny, ponieważ zamówienie nie pochodzi z zapotrzebowania
              projektowego.
            </small>
            <p class="text-primary">
              <i>Magazyn oraz nr dokumentu obliczane są na podstawie pierwszego zaznaczonego elementu.</i>
            </p>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <div class="w-75">
                <label for="selectWarehouse">Wybierz docelowy magazyn</label>
                <select class="form-select form-select-sm" id="selectWarehouse"
                        @change="onWarehouseChange">
                  <option selected disabled>-- Wybierz magazyn --</option>
                  <option value="remove_from_warehouse_wz">Ściągniecie z magazynu</option>
                  <option v-for="warehouse in availableWarehouses" :value="warehouse.id">
                    {{ warehouse.short_name }}
                  </option>
                </select>
              </div>

              <div class="w-25">
                <label class="ms-2">Manualna zmiana ruchu</label>
<select
  v-model="form.document_type"
  @change="changeDocumentType"
  class="form-select form-select-sm ms-1"
>
  <option
    v-if="form.newWarehouse?.id !== 'remove_from_warehouse_wz'"
    value="mm"
  >
    MM
  </option>

  <option value="wz">WZ</option>
  <option value="rw">RW</option>
</select>
              </div>
            </div>

            <div v-if="form" class="container-fluid">

              <template v-if="!form.newWarehouse?.id">
                Brak ruchu magazynowego
              </template>

              <template v-else>

                <div v-if="form">
                  <table class="table order-list-table">
                    <tbody>
                    <tr>
                      <td class="widthFirstTd">Numer Dokumentu</td>
                      <td>
                        {{ form.document_number }}
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Magazyn po zmianie</td>
                      <td>
                        {{ form.newWarehouse.short_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Numer zamówienia</td>
                      <td>
                        {{ form.order_number }}
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Komentarz</td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               v-model="form.comment">
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Osoba wydająca</td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               v-model="form.who_issuing">
                      </td>
                    </tr>
                    <tr v-if="form.newWarehouse?.id !== 'remove_from_warehouse_wz'">
                      <td class="widthFirstTd">Osoba przyjmująca</td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               v-model="form.who_receiving">
                      </td>
                    </tr>
					<tr
  v-if="
    form.newWarehouse?.id === 'remove_from_warehouse_wz'
    && form.document_type === 'wz'
  "
>
                      <td class="widthFirstTd">Dane kontrachenta</td>
                      <td>
<div class="position-relative">
  <label class="form-label" for="customer_search">Wybierz klienta:</label>

  <input
    id="customer_search"
    type="text"
    class="form-control form-control-sm"
    v-model="customerSearch"
    placeholder="Wpisz nazwę klienta..."
    @focus="showDropdown = true"
    @blur="hideDropdown"
  />

  <div
    v-if="showDropdown && filteredCustomers.length"
    class="border rounded bg-white position-absolute w-100 z-3"
    style="max-height: 200px; overflow-y: auto;"
  >
    <div
      v-for="customer in filteredCustomers"
      :key="customer.id"
      class="px-2 py-1 hover-bg"
      style="cursor: pointer;"
      @mousedown.prevent="selectCustomer(customer)"
    >
      {{ customer.name }}
    </div>
  </div>
</div>
  <textarea v-model="form.who_buying"	class="form-control form-control-sm mt-2" rows=4></textarea>
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Cel wydania</td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               v-model="form.purpose">
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Data podpisania
                        <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="right"
                           data-bs-html="true" title="Można zmienić w późniejszym czasie."></i>
                      </td>
                      <td>
                        <input type="date" class="form-control form-control-sm"
                               v-model="form.signed_date">
                      </td>
                    </tr>
                    <tr>
                      <td class="widthFirstTd">Notka na dokumencie
                        <i class="bi bi-info-circle" data-bs-toggle="tooltip" data-bs-placement="right"
                           data-bs-html="true" title="Można zmienić w późniejszym czasie."></i>
                      </td>
                      <td>
                        <input type="text" class="form-control form-control-sm"
                               v-model="form.additional_comment">
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colspan="2" style="border-bottom: 0">
                        <table class="table mt-4">
                          <thead>
                          <tr>
                            <th>Nr&nbsp;artykułu</th>
                            <th>Model&nbsp;art.</th>
                            <th>Z&nbsp;zamówienia</th>
                            <th>W&nbsp;rezerwacji</th>
                            <th>Stan mag.</th>
                            <th>Ilość</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(selectedItem, k) in form.selectedItems"
                              :key="selectedItem.id">
                            <td>{{ selectedItem.article?.catalog_number }}</td>
                            <td>{{ selectedItem.article?.model }}</td>
                            <td>{{ selectedItem.order_list?.order_number }}</td>
                            <td>{{ calculateReservedQuantity(selectedItem.article?.reservations) }}</td>
                            <td>{{ selectedItem.quantity }}</td>
                            <td>
                              <template v-if="selectedItem.can_disposition && selectedItem.can_disposition > 0">
                                <div v-if="selectedItem.quantity_disposed === null
                              || selectedItem.quantity_disposed === ''
                              || selectedItem.quantity_disposed < 0"
                                     class="text-danger small">
                                  Ilość musi być większa lub równa 0
                                </div>

                                <input type="number" :step="selectedItem.article?.article_unit?.allow_decimal ? 0.1 : 1"
                                       min="0" :max="selectedItem.can_disposition"
                                       class="form-control form-control-sm" v-model="selectedItem.quantity_disposed"
                                       @change="onChangeQuantityDisposed(k, $event)">
                              </template>
                              <template v-else>
                                Brak wolnej ilości tego artykułu do dyspozycji.
                              </template>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </template>
            </div>
          </div>
          <div v-else class="alert alert-danger">
            Nie można wykonać ruchu magazynowego ponieważ zaznaczono różne projekty lub zespoły.
          </div>

          <div class="modal-footer" v-if="hasSameProjectAndTeamName()">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>
            <form @submit.prevent="saveMovement" v-show="(form.oldWarehouse?.id !== form.newWarehouse?.id)">
              <button type="submit" class="btn btn-primary"
                      :disabled="form.processing
                      || (form.quantity === null || form.quantity === '' || form.quantity <= 0)">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Modal, Tooltip} from "bootstrap";
import {useForm, usePage} from "@inertiajs/vue3";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";

export default {
  components: {'ejs-datepicker': DatePickerComponent},
  props: {
    project: Number | String,
    team: String,
    selectedItems: Object,
    checkWarehouses: true,
		customers: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      errors: {},
      firstItem: {},
		warehouses: [],
		availableWarehouses: [],
      canDisposition: 0,
      isInitialChangeFired: false,
      dueDateFormat: 'dd.MM.yyyy',
	  	  		customerSearch: '',
showDropdown: false,
      form: useForm({
        selectedItems: [],
		order_number: '',
        oldWarehouse: null,
        newWarehouse: null,
        document_type: 'mm',
        document_number: '',
        comment: '',
        who_issuing: `${usePage().props.user.first_name || ''} ${usePage().props.user.last_name || ''}`,
        who_receiving: '',
        who_buying: '',
        purpose: '',
        signed_date: '',
        additional_comment: '',
      })
    }
  },
computed: {
  filteredCustomers() {
    if (!this.customerSearch) return this.customers

    return this.customers.filter(c =>
      c.name.toLowerCase().includes(this.customerSearch.toLowerCase())
    )
  }
},
  watch: {
    selectedItems: {
      immediate: true,
      async handler(newValue) {
        if (!newValue || (Array.isArray(newValue) && newValue.length === 0)) return;

        const items = Array.isArray(newValue) ? newValue : [newValue];
        this.firstItem = items[0];

        // Domyślnie pokazuj wszystkie magazyny
        this.availableWarehouses = this.warehouses;

        // Jeśli nie pochodzi z zapotrzebowania, to ogranicz do głównego
        if (!this.firstItem?.quote_request_item_id && this.checkWarehouses) {
          this.availableWarehouses = this.warehouses.filter(w => w.name === 'Główny');
        }

        // Szukaj domyślnego magazynu po numerze projektu
        const defaultWarehouse = this.availableWarehouses.find(
            w => this.firstItem?.project?.number?.toLowerCase() === w.short_name?.toLowerCase()
        ) || this.availableWarehouses.find(w => w.id === 1); // fallback: Główny

        // pobierz stary warehouse
        const oldWarehouse = newValue[0]?.article_warehouse ?
            {id: newValue[0]?.article_warehouse?.id, name: newValue[0]?.article_warehouse?.name}
            : null;

        // Wygeneruj numer dokumentu
this.form.document_type = 'mm';

const documentNumber = await this.generateDocumentNumber(
    oldWarehouse,
    defaultWarehouse,
    this.firstItem.order_lists_item_id,
    this.firstItem.quote_request_item_id || false,
    'mm'
);

this.form.document_number = documentNumber;
this.form.selectedItems = this.calculateDispositionData(items);
this.form.oldWarehouse = this.firstItem.article_warehouse;
this.form.newWarehouse = defaultWarehouse;
this.form.document_type = documentNumber.slice(0, 2).toLowerCase();
this.form.comment = '';
this.form.who_issuing = `${usePage().props.user.first_name || ''} ${usePage().props.user.last_name || ''}`;
this.form.who_receiving = '';
this.form.who_buying = '';
this.form.purpose = '';
this.form.signed_date = '';
this.form.additional_comment = '';

        this.$nextTick(() => {
          if (defaultWarehouse?.id && document.getElementById('selectWarehouse')) {
            document.getElementById('selectWarehouse').value = defaultWarehouse.id;
          }
        });
      }
    }

  },
beforeUnmount() {
  this.$refs.modalEle?.removeEventListener(
    'hidden.bs.modal',
    this.onModalHidden
  );
},
async mounted() {
  this.modalObj = new Modal(this.$refs.modalEle);
  new Tooltip(document.body, {
    selector: "[data-bs-toggle='tooltip']",
  });
this.$refs.modalEle.addEventListener(
'hidden.bs.modal',
this.onModalHidden
);
  await this.getWarehouses();

  // Po pobraniu magazynów ponownie przelicz domyślny magazyn
  if (this.selectedItems && (
    Array.isArray(this.selectedItems)
      ? this.selectedItems.length > 0
      : Object.keys(this.selectedItems).length > 0
  )) {
    await this.$options.watch.selectedItems.handler.call(
      this,
      this.selectedItems
    );
  }
},

  methods: {
  onModalHidden() {
  this.$emit('clear-selection');
},
  selectCustomer(customer) {
  this.form.customer_id = customer.id
  this.customerSearch = customer.name
  this.showDropdown = false

  const data = customer.customers_data || {}

  const lines = [
    customer.name,
    data.address,
    [data.zip_code, data.city].filter(Boolean).join(' ')
  ].filter(Boolean)

  this.form.who_buying = lines.join('\n')
},

  hideDropdown() {
    // mały delay żeby click zdążył złapać wybór
    setTimeout(() => {
      this.showDropdown = false
    }, 150)
  },
    hasSameProjectAndTeamName() {
      if (!this.selectedItems || this.selectedItems.length === 0 || Object.keys(this.selectedItems).length === 0) {
        return false; // Brak artykułów, zwracamy false
      }

      const firstProjectId = this.selectedItems[0]?.project_id;
      const firstTeamName = this.selectedItems[0]?.team_name;


      const items = this.selectedItems || [];
      const sameProjectId = items.length > 0 && items.every(article => article?.project_id === firstProjectId);
      const sameTeamName = items.length > 0 && items.every(article => article?.team_name === firstTeamName);

      return sameProjectId && sameTeamName;
    },

    // Oblicza łączną ilość zarezerwowaną (ale jeszcze nie zrealizowaną)
    calculateReservedQuantity(reservations = []) {
      return reservations.reduce((total, item) => {
        // Dla każdej rezerwacji: ilość do odjęcia to różnica między zarezerwowaną a zrealizowaną
        return total + (item.quantity_reserved - item.fulfilled_quantity);
      }, 0);
    },

async getWarehouses() {
  try {
    const response = await axios.get(route('get.article-warehouses'));
    this.warehouses = Array.isArray(response.data)
      ? response.data
      : [];
    this.availableWarehouses = [...this.warehouses];
  } catch (error) {
    this.warehouses = [];
    this.availableWarehouses = [];

    console.error('Nie udało się pobrać magazynów:', error);
  }
},

    async selectWarehouseOption(warehouseId) {
      if (document.getElementById('selectWarehouse') && warehouseId)
        document.getElementById('selectWarehouse').value = warehouseId;
    },

    onChangeQuantityDisposed(k, event) {
      let itemForm = this.form.selectedItems[k];
      if (event.target.value <= itemForm.can_disposition) {
        itemForm.quantity_disposed = event.target.value;
      } else {
        itemForm.quantity_disposed = itemForm.can_disposition;
        this.selectedItems[k].quantity_disposed = itemForm.can_disposition;
      }
    },

    async onWarehouseChange(event) {
      const value = event.target.value;

      let newWarehouse, documentNumber;

      // Jeżeli wybieramy "Ściągnięcie z magazynu"
if (value === 'remove_from_warehouse_wz') {
  newWarehouse = {
    id: 'remove_from_warehouse_wz',
    name: 'Ściągnięcie z magazynu'
  };

  this.form.document_type = 'wz';

  documentNumber = await this.generateDocumentNumber(
      null,
      'remove_from_warehouse_wz',
      null,
      false,
      'wz'
  );
} else {
  newWarehouse = this.availableWarehouses.find(
    item => item.id === parseInt(value)
  );

  this.form.document_type = 'mm';

  documentNumber = await this.generateDocumentNumber(
      this.selectedItems[0].article_warehouse,
      newWarehouse,
      this.selectedItems[0].order_lists_item_id,
      this.selectedItems[0].quote_request_item_id || false,
      'mm'
  );
}

      // Uaktualniamy tylko te pola, które się zmieniły!
      this.form.newWarehouse = newWarehouse;
     // this.form.document_type = documentNumber.slice(0, 2).toLowerCase();
      this.form.document_number = documentNumber;
      this.form.selectedItems = this.calculateDispositionData(this.selectedItems);
    },


    formatDate(date) {
      if (!date)
        return '';

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },

    async generateDocumentNumber(oldWarehouse, newWarehouse, order_list_item_id, from_quote_request = false, documentType = false) {
      const response = await axios.get(
          route('warehouse-movements.generate-document-number-json', {
            document_type: documentType,
            order_list_item_id: order_list_item_id,
            oldWarehouse: oldWarehouse,
            newWarehouse: newWarehouse,
            fromQuoteRequest: this.checkWarehouses ? from_quote_request : false
          })
      );
      return response.data.number; // Zwracanie numeru dokumentu
    },

    async changeDocumentType(event) {
      this.form.document_number = await this.generateDocumentNumber(
          this.selectedItems[0].article_warehouse,
          this.form.newWarehouse,
          this.selectedItems[0].order_lists_item_id,
          this.selectedItems[0].quote_request_item_id || false,
          event.target.value || null
      )
    },

async saveMovement() {
  // usuń zbędne dane
  this.form.selectedItems.forEach(item => {
    item?.article_warehouse;
    delete item.project;
	 item.order_number = this.form.order_number || null;
  });

  let response = await axios.post(route('warehouse-movements.store'), {
    data: this.form
  });

  if (response.status === 200) {
    this.$emit('added-success', response.data);
    this.$emit('added-movement', true);
	
  } else {
    this.$emit('added-error', response.data);
  }
  this.$emit('update-grid', true);
  this.form.processing = false;

  this.hide();
},

    hasError(field) {
      return this.errors && this.errors[field];
    },

    getErrorMessage(field) {
      if (!this.errors[field]) {
        return '';
      }

      if (/^Pole .*? jest wymagane\.$/.test(this.errors[field])) {
        return 'To pole jest wymagane.';
      }

      return 'To pole ma niepoprawną wartość';
    },

    calculateDispositionData(items) {
      // Przekształca dane wejściowe (np. artykuły) i oblicza możliwą ilość do dysponowania
      return items.map(item => {
        // Ustal dostępność: preferuj delivered_quantity, potem ilość z magazynu, potem ogólną ilość
        const delivered = parseFloat(item?.delivered_quantity) || 0;
        const warehouseQuantity = parseFloat(item.article_main_warehouse?.quantity) || 0;
        const baseQuantity = parseFloat(item?.quantity) || 0;

        // Wybierz pierwszą sensowną wartość jako ilość dostępną
        const availableQuantity = delivered || warehouseQuantity || baseQuantity;

        // Oblicz sumę wszystkich niezrealizowanych rezerwacji dla danego artykułu
        const reservedQuantity = this.calculateReservedQuantity(item.article?.reservations || []);

        // Od dostępnej ilości odejmij zarezerwowaną
        let can_disposition = availableQuantity - reservedQuantity;

        // Nie pozwalaj na wartości ujemne
        if (can_disposition < 0) can_disposition = 0;

        // Zwróć nowe dane z wyliczonymi polami
        return {
          ...item,
          can_disposition,     // ilość, którą można jeszcze rozdysponować
          quantity_disposed: 0 // domyślnie 0, ale można ustawiona ilość do rozdysponowania czyli can_disposition
        };
      });
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>


<style scoped>
.widthFirstTd {
  width: 250px;
}

.order-list-table:not(:first-child) {
  border-top: 2px solid #222;
}
</style>